import { ValidationErrorMessages } from '@constants/forms';
import { BooleanSelection } from '@src/types/index';
import { validatePhoneNumber } from '@utils/validators';

import { SimSettingsFormErrors, SimSettingsFormValues } from '../types';

const validateForm = (values: SimSettingsFormValues) => {
  const {
    simPlanId,
    isKeepNumber,
    isCancelNumber,
    keepNumber,
    cancelNumber,
    pacNumber,
    stacNumber,
  } = values;
  const errors: SimSettingsFormErrors = {};

  if (!simPlanId) {
    errors.simPlanId = ValidationErrorMessages.FIELD_REQUIRED;
  }

  const selectedKeepNumber = isKeepNumber === BooleanSelection.Yes;

  if (selectedKeepNumber) {
    if (!keepNumber) {
      errors.keepNumber = ValidationErrorMessages.FIELD_REQUIRED;
    } else if (!validatePhoneNumber(keepNumber)) {
      errors.keepNumber = ValidationErrorMessages.INVALID_PHONE;
    }

    if (!pacNumber) {
      errors.pacNumber = ValidationErrorMessages.FIELD_REQUIRED;
    }
  }

  const selectedCancelNumber =
    !selectedKeepNumber && isCancelNumber === BooleanSelection.Yes;

  if (selectedCancelNumber) {
    if (!cancelNumber) {
      errors.cancelNumber = ValidationErrorMessages.FIELD_REQUIRED;
    } else if (!validatePhoneNumber(cancelNumber)) {
      errors.cancelNumber = ValidationErrorMessages.INVALID_PHONE;
    }

    if (!stacNumber) {
      errors.stacNumber = ValidationErrorMessages.FIELD_REQUIRED;
    }
  }

  return errors;
};

export { validateForm };
